module.exports = "<template> <span class.bind=\"sort == 'ASC' ? 'fa fa-sort-up' : (sort == 'DESC' ? 'fa fa-sort-down' : 'fa fa-sort')\"></span> </template> ";